import { computed } from 'vue'
import { useStore } from 'vuex'

// The page keeps asking for chunks of the build it was loaded with, and a deploy
// takes those away: the tab has to be reloaded, so the operator is asked to.
export const useNewRelease = () => {
  const store = useStore()
  const loaded = document
    .querySelector('meta[name="release"]')
    ?.getAttribute('content')

  const available = computed(() => {
    const current = store.getters['stats/getStats']?.release
    return Boolean(loaded && current && current !== loaded)
  })

  return { available, reload: () => window.location.reload() }
}
